import React, { useRef, useState, useEffect } from "react";
import defaultFile from "../../../assets/images/default-file.png";
import pdfFile from "../../../assets/images/pdf-file.png";
import pngFile from "../../../assets/images/png-file.png";
import cssFile from "../../../assets/images/css-file.png";
import dragAndDrop from "../../../assets/images/drag-and-drop.png";

const ImageConfig = {
  default: defaultFile,
  pdf: pdfFile,
  png: pngFile,
  css: cssFile,
};

const DropFileInput = ({ field, form, oldPictures, setFieldValue }) => {
  const wrapperRef = useRef(null);
  const [fileList, setFileList] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    if (typeof oldPictures === "string") {
      setImageUrls(
        oldPictures
          .split(",")
          .map((url) => url.trim())
          .filter(Boolean)
      );
    } else if (Array.isArray(oldPictures)) {
      setImageUrls(oldPictures.filter(Boolean));
    } else {
      setImageUrls([]);
    }
  }, [oldPictures]);

  const onDragEnter = () => wrapperRef.current?.classList.add("dragover");
  const onDragLeave = () => wrapperRef.current?.classList.remove("dragover");
  const onDrop = () => wrapperRef.current?.classList.remove("dragover");

  const onFileDrop = (e) => {
    const newFiles = Array.from(e.target.files);
    if (newFiles.length) {
      const updatedList = [...fileList, ...newFiles];
      setFileList(updatedList);
      form.setFieldValue(field.name, updatedList);
    }
  };

  const fileRemove = (file) => {
    const updatedList = fileList.filter((item) => item !== file);
    setFileList(updatedList);
    form.setFieldValue(field.name, updatedList);
  };

  const handleRemoveImage = (imageToRemove) => {
    setImageUrls((prevImages) => {
      const updatedImages = prevImages.filter(
        (img) => img.trim() !== imageToRemove.trim()
      );
      setFieldValue("imageUrl", updatedImages.join(","));
      return updatedImages;
    });
  };

  return (
    <div className="drop-file-container d-flex flex-column flex-md-row">
      <div
        ref={wrapperRef}
        className="drop-file-input"
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <div className="drop-file-input-label">
          <img src={dragAndDrop} alt="Drag and drop" />
          <p>Drag & Drop product images here or click</p>
        </div>
        <input
          type="file"
          className="file-upload"
          accept=".png, .jpg, .jpeg"
          id="images"
          multiple
          onChange={onFileDrop}
        />
      </div>

      {(fileList.length > 0 || imageUrls?.length > 0) && (
        <div className="drop-file-preview">
          <p className="drop-file-preview-title">Ready to upload</p>
          <div className="preview-grid">
            {/* Existing Images */}
            {imageUrls.length > 0 &&
              imageUrls.map((item, index) => (
                <div
                  key={`existing-${index}`}
                  className="drop-file-preview-item"
                >
                  <div className="image-container">
                    <img
                      src={item}
                      alt={`preview-${index}`}
                      className="preview-image"
                    />
                  </div>
                  <span
                    className="drop-file-preview-item-del"
                    onClick={() => handleRemoveImage(item)}
                    title="Remove image"
                  >
                    ×
                  </span>
                </div>
              ))}

            {/* New Files */}
            {fileList.length > 0 &&
              fileList.map((item, index) => (
                <div key={`new-${index}`} className="drop-file-preview-item">
                  <div className="file-info-container">
                    <img
                      src={
                        ImageConfig[item.type.split("/")[1]] ||
                        ImageConfig["default"]
                      }
                      alt="File icon"
                      className="file-icon"
                    />
                    <div className="drop-file-preview-item-info">
                      <p className="file-name">{item.name}</p>
                      <p className="file-size">
                        {Math.round(item.size / 1024)}KB
                      </p>
                    </div>
                  </div>
                  <span
                    className="drop-file-preview-item-del"
                    onClick={() => fileRemove(item)}
                    title="Remove file"
                  >
                    ×
                  </span>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropFileInput;
